import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router';

import { logout } from '../../../api/services/authServices';
import GrvPersonEncircled from '../../../assets/grv-person-encircled.svg?react';
import GrvSettings from '../../../assets/grv-settings.svg?react';
import GrvSignOut from '../../../assets/grv-sign-out.svg?react';
import { EXTERNAL_URLS } from '../../../constants/urls';
import { useKeyPress } from '../../../hooks/useKeyPress';
import { useOutsideClick } from '../../../hooks/useOutsideClick';

import './NavbarDropdown.scss';

export const NavbarDropdown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  const logoutAndRedirect = async () => {
    try {
      await logout();
    } catch {
      // Ignore logout errors and still navigate to home
    } finally {
      navigate(EXTERNAL_URLS.DEVELOPER_PORTAL_HOME);
    }
  };

  useOutsideClick(dropdownRef, () => {
    setDropdownOpen(false);
  });

  useKeyPress('Escape', () => {
    setDropdownOpen(false);
  });

  return (
    <div className="navbar-dropdown" ref={dropdownRef}>
      <button
        className="navbar-dropdown-button"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-label="Settings"
        aria-expanded={dropdownOpen}
        aria-haspopup="menu"
        aria-controls="navbar-dropdown-menu"
      >
        <GrvSettings className="navbar-dropdown-button-icon" />
      </button>
      {dropdownOpen && (
        <div
          id="navbar-dropdown-menu"
          className="navbar-dropdown-menu"
          role="menu"
          aria-label="Settings"
        >
          <Link
            className="navbar-dropdown-item"
            to={EXTERNAL_URLS.DEVELOPER_PORTAL_PROFILE}
            role="menuitem"
          >
            <GrvPersonEncircled className="navbar-dropdown-item-icon" />
            <span className="navbar-dropdown-item-text">Profile</span>
          </Link>
          <span
            className="navbar-dropdown-item"
            role="menuitem"
            onClick={logoutAndRedirect}
          >
            <GrvSignOut className="navbar-dropdown-item-icon" />
            <span className="navbar-dropdown-item-text">Logout</span>
          </span>
        </div>
      )}
    </div>
  );
};
